import { Typography } from "@mui/material";
import { Family } from "protogen/advisors_service_pb";
import FlexBox from "components/common/FlexBox";
import useIsMobile from "components/hooks/useIsMobile";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useListAllTaskInspirations,
  useListAllTaskInspirationCategories,
} from "services/tasks";
import { TaskInspiration } from "protogen/tasks_pb";
import { InspiredTaskList } from "components/tasks/TaskInspiration";
import useIsDesktop from "components/hooks/useIsDesktop";

export default ({ family, flex }: { family: Family; flex: number }) => {
  const navigate = useNavigate();

  const { data, request: listAllTaskInspirationRequest } =
    useListAllTaskInspirations(() => {});

  const { data: inspirationCategories, request: inspirationCategoriesRequest } =
    useListAllTaskInspirationCategories(() => {});
  useEffect(() => {
    inspirationCategoriesRequest();
    listAllTaskInspirationRequest();
  }, []);

  const commonTasks = data?.taskInspirations.filter((task) => {
    const category = inspirationCategories?.taskInspirationCategories.find(
      (cat) => cat.ref === task.categoryRef,
    );
    return category && category.title === "Popular" && task.status === "active";
  });

  const trendingTasks = data?.taskInspirations.filter((task) => {
    const category = inspirationCategories?.taskInspirationCategories.find(
      (cat) => cat.ref === task.categoryRef,
    );
    return (
      category && category.title === "Seasonal" && task.status === "active"
    );
  });

  const onTaskClick = (task: TaskInspiration) => {
    navigate("/tasks/add", {
      state: { inspiredTask: task, family: family },
    });
  };

  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();

  return (
    <FlexBox variant="contained" direction="column" sx={{ flex: flex }}>
      <Typography variant={isMobile ? "h3" : "h4"}>Task inspiration</Typography>
      <FlexBox
        direction={isDesktop ? "row" : "column"}
        gap={isMobile ? "24px" : "16px"}
      >
        {/* Task Ideas */}
        <InspiredTaskList
          title="Popular tasks"
          tasks={commonTasks || []}
          onTaskClick={onTaskClick}
          style="normal"
        />
        {isMobile && (
          <InspiredTaskList
            title="Seasonal tasks"
            tasks={trendingTasks || []}
            onTaskClick={onTaskClick}
            style="normal"
          />
        )}
      </FlexBox>
    </FlexBox>
  );
};
